import Vue from 'vue';

import NavigationOnPage from './components/navigation-on-page.vue';
import NavigationToggle from './components/navigation-toggle.vue';
import Navigation from './components/navigation.vue';

new Vue({
    el: '#vue-app',

    components: {
        Navigation,
        NavigationOnPage,
        NavigationToggle
    },

    data() {
        return {
            pageHeadings : []
        }
    },

    mounted() {
        document.querySelectorAll('h3').forEach((heading) => {
            heading.id = heading.textContent.replace(/\s+/g, '-').toLowerCase();
            this.pageHeadings.push(heading);
        });
    },
});
